//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getQueryVariable } from '@/util/const'

const lang = getQueryVariable('lang') || window.localStorage.getItem('lang')
const alert = {
  title: {
    sc: '提示',
    tc: '提示',
    en: 'Notice'
  },
  btnDefault1: {
    sc: '取消',
    tc: '取消',
    en: 'No'
  },
  btnDefault2: {
    sc: '提交',
    tc: '提交',
    en: 'Yes'
  }
}
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: alert.title[lang]
    },
    content: {
      type: String,
      default: ''
    },
    buttonText: {
      type: Array,
      default: () => {
        return [{ id: 'cancel', text: alert.btnDefault1[lang] }, { id: 'ok', text: alert.btnDefault1[lang] }]
      }
    }
  },
  data () {
    return {
      type: 'model',
      promiseStatus: null
    }
  },
  methods: {
    confirm (type) {
      if (type) {
        this.type = type
      }
      let _this = this
      this.value = true
      return new Promise(function (resolve, reject) {
        _this.promiseStatus = { resolve, reject }
      })
    },
    handle (id) {
      if (this.type === 'model') {
        this.$emit('input', false)
      } else {
        this.value = false
      }
      if (id === 'ok') {
        this.promiseStatus && this.promiseStatus.resolve()
      }
      if (id === 'cancel') {
        this.promiseStatus && this.promiseStatus.reject()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/component/uiConfirm/uiConfirm.vue